import * as React from 'react'
import Tippy, {TippyProps} from '@tippyjs/react'

type Props = Omit<
  React.HTMLProps<HTMLDivElement>,
  'content' | 'ref' | 'children'
> &
  TippyProps & {
    zIndex?: number
  }

export const Tooltip = ({visible, ...props}: Props) => {
  if (!props.content || props.disabled) {
    return props.children || null
  }
  return (
    <Tippy
      trigger={visible === undefined ? 'mouseenter' : undefined}
      visible={visible}
      offset={[2, 2]}
      delay={[300, 0]}
      duration={[400, 0]}
      zIndex={props.zIndex ?? 1000}
      {...props}
    />
  )
}
